<template>
              
			<div class="wtips_uom_single_view col-wrapper col-lg-12 col-md-12 col-sm-12 col-xs-12">
			   
				<div class="module-wrapper">
				   
					<section class="module module-has-footer module-projects-overview">
					
						<div class="module-inner">
							<div class="module-heading">
								<h3 class="module-title">Viewing UOM Code : <span class="pro-label label label-info btn-sm">{{uom_data.uom_code}}</span></h3>
								<ul class="actions list-inline">
									<li><a class="collapse-module" data-toggle="collapse" href="#content-overview" aria-expanded="false" aria-controls="content-overview"><span aria-hidden="true" class="icon arrow_carrot-up"></span></a></li>
								</ul>
							</div>
							
							<div class="module-content collapse in" id="content-overview">
								<div class="module-content-inner">

                                  <div class="row">
									<div class="form-group col-md-6">
										<label>UOM Code</label>
										<input type="text" class="form-control" id="uom_code" placeholder="Enter an UOM code" :value="uom_data.uom_code" readonly>
									</div>
 									<div class="col-md-6">
										<label>UOM Desc</label>
										<input type="text" class="form-control" placeholder="Enter an UOM Desc" :value="uom_data.uom_desc" readonly>
									</div>                                  
									
                                     
                                
                                </div>                                  
                                 
                                 <button type="button" class="btn btn-primary" @click="show_uom_table">Close</button>                                 
                                                                                                                                    
							
				              
				              </div>
								
							</div>
							
						</div>
						
				        <div class="module-footer text-center">
                            <p class="meta"><span><li>Created By: {{ uom_data.cr_user_code }} at : {{uom_data.cr_datetime}}</li></span>&nbsp;&nbsp;<span><li>Modified By: {{ uom_data.md_user_code }} at : {{ uom_data.md_datetime }} </li></span></p>
    </div>
						
						 <spinner :visible="ajax_loader"></spinner>
					</section>
					
				</div>		
            </div>	
            
<!--row -->	 
       
</template>


<script>
import modalnotify from '@/components/supportcomp/modalnotify.vue' 
import spinner from '@/components/supportcomp/spinner.vue' 

export default {
  name: 'uom_master_view_single',
  props: {
      visible: {
            type:Boolean
              },
      picked_uom : ''
  },    
  data () {
    return {    
      msg: '',
      security_ojb : '',
      modalnotify_view : false,
      modal_msg : '',   
      modal_title : '',
      ajax_loader : false,
      uom_data : ''
    }
  },
  components: {
      modalnotify,
      spinner
   },
methods: {
    
     show_uom_table : function () {
         
          $(".wtips_uom_table_view").show(600);
          $(".wtips_uom_single_view").hide(600);
          
     }
    
    


}, //end of Methods //
    
watch : {
    
    
    picked_uom : function (value){
          
                             var MstObj = this;
                             var object_data = {"data_api_key":'view_single_uom_master_data', "uom_code" : value , "base_module":"uom_master"};
                            
                             MstObj.ajax_loader=true;
                             call_Ajax("get_data_api",object_data).then(function (data){
                                     
                                      MstObj.ajax_loader=false;
                                 
                                      
                                      //MstObj.uom_data = data.data;
                                    if (data.data=="ERR"){
            
                                    }
                                     $.each( data.data, function( i, val ) {
                                                   
                                                    
                                             MstObj.uom_data = val;
                                               
                                     });                               

                             })
                              .fail(function(){
                                 MstObj.ajax_loader=false; 
                             }); //              

      }

},    
    
mounted : function () {
       var x = this;
       //setTimeout(function(){ x.setSecurity(); }, 200);
   } //end of mounted
}

</script>










// WEBPACK FOOTER //
// src/components/app-pages/uom-master/uom-master-view-single.vue